import StepAlertNextStep from '../../components/alert-next-step'

export default {
  StepAlertNextStep
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/form/resources/components.js